import React, { useEffect, useState } from 'react';
import { Form, Button, Input, Row, Col, message, Checkbox } from 'antd';
import apiClient from 'services/apiClient';
import { useMyContext } from 'Context/MyContextProvider';
import ConditionalRender from 'views/app-views/whatsapp/Utils/ConditionalRender';
import { CustomCard, CustomAlertBanner } from '../../components/AlertBadge';
import { SUCCESS, DANGER } from '../../CustomUtils.js/utils';
import { SafetyOutlined, CloseOutlined, SaveOutlined, SecurityScanOutlined } from '@ant-design/icons';
import Flex from 'components/shared-components/Flex';

const Security = ({ api, authToken, navigate, id, isMobile }) => {

    const { Permisson } = useMyContext()
    const [ipAuth, setIpAuth] = useState(false);
    const [twoFectorAuth, setTwoFectorAuth] = useState(false);
    const [ipAddresses, setIPAddress] = useState('');
    const [disable, setDisable] = useState(true)
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (Permisson?.includes('Update User Security')) {
            setDisable(false)
        }
        setLoading(true);
        apiClient.get(`${api}edit-user/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + authToken,
            }
        }).then(response => {
            // console.log(response.data.user[0])
            setIpAuth(response.data.user[0].ip_auth === 'true' ? true : false);
            setTwoFectorAuth(response.data.user[0].two_fector_auth === 'true' ? true : false);
            const ipAddressesArray = JSON.parse(response.data.user[0].ip_addresses); // Parse JSON string to array
            const commaSeparated = ipAddressesArray?.join(',');
            setIPAddress(commaSeparated);

            setLoading(false);

        })
            .catch(error => {
                setLoading(false);
                console.log(error);
            });
    }, [Permisson, api, authToken, id])

    const UpdateSecurity = async (e) => {
        e.preventDefault();
        const ipAddressesArray = ipAddresses?.split(',')?.map(ip => ip.trim());
        await apiClient.post(`${api}update-security`, {
            id,
            ip_auth: ipAuth,
            two_fector_auth: twoFectorAuth,
            ip_addresses: ipAddressesArray,
        }, {
            headers: {
                'Authorization': 'Bearer ' + authToken,
            }
        })
            .then((response) => {
                message.success(response.data.message)
            })
            .catch((error) => {
                console.log(error);
            });

    }

    const HandleIp = (e) => {
        setIpAuth(e.target.checked);
    }
    const HandleTwoFector = (e) => {
        setTwoFectorAuth(e.target.checked);
    }


    return (
        <>
            <div className="mt-4">
                {!loading && (
                    <Form
                        name="basicInformation"
                        layout="vertical"
                        disabled={disable}
                        initialValues={
                            {
                                'ip_auth': ipAuth && ipAuth,
                                'two_fector': twoFectorAuth && twoFectorAuth,
                                'IP_Addresses': ipAddresses && ipAddresses,
                            }
                        }
                    >
                        <CustomCard>
                            {/* Card Header */}
                            <Flex alignItems="center" gap="16px" style={{ marginBottom: '24px' }}>
                                <div className="manage-alerts-header-icon-wrapper" style={{ background: '#e8f5e9', borderColor: '#c8e6c9', color: '#2e7d32' }}>
                                    <SafetyOutlined />
                                </div>
                                <div className="manage-alerts-header-text">
                                    <h4 className="manage-alerts-header-title">Login Security</h4>
                                    <p className="manage-alerts-header-desc my-0" >Manage your login credentials and keep your account secure.</p>
                                </div>
                            </Flex>

                            <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '20px 0' }} />

                            <Row gutter={[32, 16]}>
                                {/* Left Column: IP Address Authentication */}
                                <Col xs={24} md={12} style={{ borderRight: isMobile ? 'none' : '1px solid #f0f0f0' }}>
                                    <Form.Item
                                        name="ip_auth"
                                        valuePropName="checked"
                                    >
                                        <Checkbox checked={ipAuth} onChange={HandleIp}>
                                            IP Address Authentication
                                        </Checkbox>
                                    </Form.Item>

                                    <div style={{ marginTop: '16px' }}>
                                        <Form.Item
                                            label={'Your IP Address'}
                                            name="IP_Addresses"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input your IP Addresses!',
                                                },
                                            ]}
                                            extra={<div style={{ fontSize: '12px', color: '#72849a', marginTop: '4px' }}>You can add multiple IP addresses separated by comma.</div>}
                                        >
                                            <Input.TextArea
                                                rows={3}
                                                placeholder="Enter your IP address"
                                                style={{ borderRadius: '8px' }}
                                                value={ipAddresses}
                                                onChange={(e) => setIPAddress(e.target.value)}
                                            />
                                        </Form.Item>
                                    </div>
                                </Col>

                                {/* Right Column: Two Factor Authentication */}
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        name="two_fector"
                                        valuePropName="checked"
                                    >
                                        <Checkbox checked={twoFectorAuth} onChange={HandleTwoFector}>
                                            Two Factor Authentication
                                        </Checkbox>
                                    </Form.Item>

                                    <p style={{ fontSize: '12px', color: '#72849a', paddingLeft: '24px', marginBottom: '20px' }}>
                                        Use 2FA with an authenticator app to create an additional layer of security for your account.
                                    </p>

                                    <div style={{ paddingLeft: '24px' }}>
                                        <CustomAlertBanner
                                            icon={<SecurityScanOutlined />}
                                            title={<span>Recommended</span>}
                                            subtitle={<span>Two Factor Authentication adds an extra layer of security and helps protect your account from unauthorized access.</span>}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '24px 0 20px 0' }} />

                            {/* Card Footer Actions */}
                            <Flex justifyContent="end" gap="12px">
                                <Button
                                    style={{ borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}
                                    onClick={(e) => navigate('/users')}
                                >
                                    Cancel
                                </Button>
                                {Permisson?.includes('Update Meta Credential') && (
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        onClick={(e) => UpdateSecurity(e)}
                                    >
                                        <SaveOutlined /> Save Changes
                                    </Button>
                                )}
                            </Flex>
                        </CustomCard>
                    </Form>
                )}
            </div>
        </>
    )
}

export default Security